import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomePage } from './home/home.page';
import { FirstPageComponent } from './auth/first-page/first-page.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'url-servico',
    pathMatch: 'full',
  },
  {
    path: 'first-page', component: FirstPageComponent
  },
  {
    path: 'auth/login', component: LoginComponent
  },
  {
    path: 'auth/change-password', component: ChangePasswordComponent
  },
  {
  path: 'auth/reset-password',
    loadComponent: () =>
      import('./auth/Reset-Password/reset-password/reset-password.component')
        .then(m => m.ResetPasswordComponent)
  },
  {
    path: 'url-servico', component: HomePage
  },
  {
    path: 'gerente', loadChildren: () => import('./gerente-pages/gerente-pages-routing.module').then((m) => m.GerentePagesRoutingModule)
  },
  {
    path: 'motorista', loadChildren: () => import ('./motorista-pages/motorista-pages-routing.module').then((m) => m.MotoristaPagesRoutingModule)
  }
];
